import React, { useState, useRef } from "react";
import Modal from "react-modal";
//import { isMobile } from "react-device-detect";

//Modal.setAppElement("#root");
const ModalComponent = ({ isOpen, onClose, contentUrl }) => {
  const [modalSize, setModalSize] = useState({
    contentWidth: "auto",
    contentHeight: "auto",
  });

  const iframeRef = useRef(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);

  const handleResize = () => {
    setIsMobile(window.innerWidth < 992);
  };
  const handleIframeLoad = () => {
    // Access the content document inside the iframe

    const iframeElement = iframeRef.current;
    //console.log("Iframe loaded:", iframeElement);

    setTimeout(() => {
      const contentDocument =
        iframeRef.current.contentDocument ||
        iframeRef.current.contentWindow.document;

      // Get the dimensions of the content
      const contentWidth = contentDocument.body.scrollWidth;
      const contentHeight = contentDocument.body.scrollHeight;

      // Update the modal size
      setModalSize({
        // contentWidth: `${contentWidth}px`,
        contentWidth: `${contentWidth}`,
        contentHeight: `${contentHeight}`,
        // contentHeight: `${contentHeight}px`,
      });
    }, 1000);
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      style={{
        content: {
          width: isMobile ? 375 : 480, //{ contentWidth },
          height: 600, // isMobile ? "60%" : "50%",
          inset: 20,
          margin: "auto",
          border: "0px",
          borderWidth: "0px",
          padding: "20px",
          borderRadius: "20px",
          boxShadow: "0px 8px 16px rgba(0, 0, 0, 0.25)",
          overflow: "hidden",
          //marginLeft: isMobile ? -15 : "auto",
        },
      }}
    >
      <span
        className="close"
        onClick={onClose}
        style={{
          float: "right",
          fontSize: "24px",
          cursor: "pointer",
          marginBottom: "5px",
          top: "0.5em",
          right: "0.5em",
          textDecoration: "none",
          color: "#fff",
          // backgroundColor: "gray",
          display: "block",
          width: "1em",
          height: "1em",
          borderRadius: "50%",
          textAlign: "center",
          lineHeight: "0.7",
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="24"
          viewBox="0 -960 960 960"
          width="24"
        >
          <path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"></path>
        </svg>
      </span>
      <iframe
        id="iframeLogin"
        ref={iframeRef}
        title=""
        width="100%"
        height="100%"
        src={contentUrl}
        onLoad={handleIframeLoad}
        //frameBorder="0"
        allowFullScreen
        scrolling="no"
      ></iframe>
      {/* <div
        style={{
          width: "100%",
          height: "100%",
          paddingLeft: 20,
          paddingRight: 20,
          paddingTop: 10,
          paddingBottom: 20,
          background: "white",
          borderRadius: 0,
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "flex-start",
          gap: 20,
          display: "inline-flex",
        }}
      >
        {content}
      </div> */}
      {/* <button onClick={onClose}>Close</button> */}
    </Modal>
  );
};

export default ModalComponent;
